export const isToday = (dateStr: string) => {
  const today = new Date();

  const todayStr = today.toISOString().split("T")[0];

  return dateStr === todayStr;
};
